import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SocialIcon } from 'react-social-icons'

const SocialIcons = () => (
  <div className="social-icons-wrapper">
    <Swiper spaceBetween={20} slidesPerView="auto" className="social-icons-slider" freeMode={true}>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://facebook.com" />
      </SwiperSlide>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://instagram.com" />
      </SwiperSlide>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://linkedin.com" />
      </SwiperSlide>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://twitter.com/jaketrent" />
      </SwiperSlide>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://tiktok.com" />
      </SwiperSlide>
      <SwiperSlide className="social-swiper-slide">
        <SocialIcon url="https://pinterest.com" />
      </SwiperSlide>
    </Swiper>
  </div>
)

export default SocialIcons
